import Vue from 'vue'
import App from './components/_application'

new Vue(App).$mount('#app')



// WEBPACK FOOTER //
// ./src/scripts/main.js